import { TErrorType, useErrorStore } from '@/stores/error';

export const handleAPIErrors = (key: keyof TErrorType, error?: any) => {
    const { setErrorWithKey, setError } = useErrorStore();

    setErrorWithKey(key);
    if (error) {
        setError(error);
    }
    throw new Error(`There was an issue with ${key} request`);
};
